<template>
  <div>
    <vxe-form>
      <vxe-form-item>
        <template v-slot>
          <vxe-input v-model="searchVal" :placeholder="$t('message.placeholder.search')"
            @keyup.enter.native="searchClick" :disabled='advancedSearch'></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item>
        <template v-slot>
          <div style="display:flex;">
            <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">{{
              $t("message.button.search") }}</el-button>
            <el-button type="success" icon="el-icon-folder-checked" size="small" @click="checkClick">{{
              $t("message.button.submit") }}</el-button>
            <el-button type="info" icon="el-icon-search" size="small" @click="searchTypeToggle"
              v-if="advancedSearchShow" v-show="advancedSearchChange">{{ !advancedSearch ?
                $t("message.button.advancedSearch") :
                $t("message.button.simpleSearch") }}</el-button>
            <span style="margin: 0 10px">
              <slot> </slot>
            </span>
            <el-checkbox v-if='creatBy != "BOM" && advancedSearch' v-model="noPendingItem"
              style="margin: 13px 10px 0 10px;">{{ $t("message.title.noPendingItem") }}</el-checkbox>

            <el-select style="width: 150px" v-model="value" clearable placeholder="个人搜索" @change="handleChange">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

          </div>
        </template>
      </vxe-form-item>

    </vxe-form>
    <el-checkbox v-model="checkedSubMaterials" label="是否添加未发版的子物料" style="float: left;"></el-checkbox>
    <div class="search-line" v-if="advancedSearch">
      <SearchQuery ref="search" class="search-content" :creatBy='creatBy' :messageData='messageData' />
      <div style="margin-top:5px" v-loading="tableloading">

        <vxe-grid ref="xGrid" v-bind="addTableList" @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
          @cell-dblclick="dbClick">

          <template #BOMTagShow="{ row }">
            <!-- <span>{{ row.BomTag }} <i :class="row.BomTag" :title="row.BomTag"></i></span> -->
            <i class="el-icon-news" title="BomTag" v-show="row.BomTag"></i>
          </template>
          <template #workflowTagShow="{ row }">
            <span>{{ showIcon(row.pendingChangeTag) }}</span>
            <i class="el-icon-data-line" title="pendingChangeTag" v-show="row.pendingChangeTag"></i>
          </template>
          <template #manufacterTagShow="{ row }">
            <span>{{ showIcon(row.manufacturerTag) }}</span>
            <i class="el-icon-office-building" title="manufacturerTag" v-show="row.manufacturerTag"></i>
          </template>
          <template #attchmentTagShow="{ row }">
            <span>{{ showIcon(row.attachmentTag) }}</span>
            <i class="el-icon-paperclip" title="attachmentTag" v-show="row.attachmentTag"></i>
          </template>

          <template #quantityEdit="{ row }">
            <vxe-input v-model="row.quantity"></vxe-input>
          </template>
          <template #departmentShow="{ row }">
            <span>{{ formatDepartment(row.department) }} </span>
          </template>
          <template #departmentEdit="{ row }">
            <vxe-select v-model="row.department" multiple clearable>
              <vxe-option v-for="item in departmentList" :key="item.value" :value="item.value"
                :label="item.label"></vxe-option>
            </vxe-select>
          </template>
          <template v-slot:toolbar>
            <vxe-toolbar custom>
              <template v-slot:buttons> </template>
            </vxe-toolbar>
          </template>
        </vxe-grid>
      </div>
    </div>

    <div v-loading="tableloading" v-if="!advancedSearch">
      <vxe-grid ref="xGrid" v-bind="addTableList" @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
        @cell-dblclick="dbClick">
        <template #quantityEdit="{ row }">
          <vxe-input v-model="row.quantity"></vxe-input>
        </template>
        <template #departmentShow="{ row }">
          <span>{{ formatDepartment(row.department) }}</span>
        </template>
        <template #departmentEdit="{ row }">
          <vxe-select v-model="row.department" multiple clearable>
            <vxe-option v-for="item in departmentList" :key="item.value" :value="item.value"
              :label="item.label"></vxe-option>
          </vxe-select>
        </template>
        <template v-slot:toolbar>
          <vxe-toolbar custom>
            <template v-slot:buttons> </template>
          </vxe-toolbar>
        </template>
      </vxe-grid>
    </div>

    <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="pageSizes" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
    </el-pagination>

  </div>
</template>
<script>
import axios from "axios";
// import SearchItem from "@/views/workBench/search/searchItem/searchItem.vue";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";

export default {
  name: "searchAdd", //模板名称
  data() {
    return {
      advancedSearchShow: false,
      noPendingItem: true,

      advancedSearch: false,
      pageInfo: [],

      searchVal: "",
      get_change_info: "",
      rols_text: [],
      tableShow: false,
      oldTableValue: [],
      rols_text: [],
      cols: [],
      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      totalRecords: 0,
      paginationShow: false,

      loading: false,
      rowStyle: { cursor: "pointer" },
      tableToolbar: {
        buttons: [{ code: "myInsert", name: "", type: "text" }],
        // print: true,
        // export: true,
        // zoom: true,
        custom: true,
        slots: {
          tools: "tools",
        },
      },

      TagList: [],
      linkProperty: '',
      ll: [
        "el-icon-news",
        "el-icon-data-line",
        "el-icon-office-building",
        "el-icon-paperclip",
      ],
      colorList: ["#13ce66", "#fcad2c", "#F56C6C", "#38A8F6"],
      iconType: [],

      addTableList: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [],
        data: [],

        editConfig: {
          trigger: "dblclick",
          mode: "cell",
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
        // checkboxConfig:{
        //   labelField: 'name',
        //   checkMethod: this.checkboxMethod}
      },
      validRules: {
        quantity: [
          { required: true, }
        ],
        department: [
          { required: true, }
        ],
      },
      advancedSearchChange: true,
      tableloading: false,
      checkedSubMaterials: true,
      messageData: "NO",
      options: [],
      value: '',
    };
  },
  mounted() {
    this.getPersonalSearchListData();
  },
  components: {
    // SearchItem,
    SearchQuery
  },
  props: ['creatBy', 'departmentList', 'noAdvancedSearch'],
  methods: {

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchClick();

    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchClick();
      // const { data: res } = await this.$http.get(loadTableUrl);
    },

    showIcon(e) {
      // console.log(row);

    },

    selectAllEvent({ checked, row }) {
      // const records = this.$refs.xTable1.getCheckboxRecords()
      const records = this.$refs.xGrid.getCheckboxRecords();
      // console.log(checked ? '所有勾选事件' : '所有取消事件', records)
      console.log(checked, 'All');
      if (checked) {
        records.map(i => {
          if (!i.quantity) {
            i.quantity = '1'
          }
        })
      }
    },
    selectChangeEvent({ checked, row }) {
      // const records = this.$refs.xTable1.getCheckboxRecords()
      // console.log(checked ? '勾选事件' : '取消事件', records)
      console.log(checked, row);

      if (checked && !row.quantity) {
        row.quantity = '1'
      }
    },

    searchTypeToggle() {
      this.advancedSearch = !this.advancedSearch;
      this.TagList = [];
      this.addTableList.columns = [];
      this.addTableList.data = [];
      this.paginationShow = false;
      this.searchVal = "";
      this.value = "";
      this.messageData = "NO";

    },
    cellClick({ row, column }) {
      console.log(column.property, this.linkProperty);
      // if (column.property == this.linkProperty) {
      //   this.rowClick(row);
      // }
    },
    activeRowMethod(row) {
      console.log(row);
      // console.log(rowIndex);
      // console.log(column);
      // console.log(columnIndex);
      if (row.column.field === "quantity" || row.column.field === "department") {
        return true;
      }
      // return true;
      // return true;
    },

    getItemData(data) {
      let columnlist = [];
      this.TagList = [];
      this.iconType = [];
      this.seekId = data["tableP1"]?.seekId;
      this.seekColumns = data["tableP1"]?.saveColumns ?? "";
      let arr = Object.values(data)
        .filter((i) => i.tableID)
        .sort((a, b) => {
          return b.tableID - a.tableID;
        });
      let dataRows = arr.map((item) => {
        let tempRow = [];
        const n = item.columnInfo.names.map((i, e) => ({
          title: i,
          field: item.columnInfo.ids[e].toString(),
          minWidth: "140",
          sortable: true,
          editRender: "{}"
        }));
        columnlist = [...n, ...columnlist];
        item.rows.map((j) => tempRow.push(j.cells));
        return tempRow;
      });
      dataRows = dataRows.filter((i) => !!i.length);


      if (!dataRows.length) {
        this.totalRols = dataRows.length;
        this.tableToolbar.buttons[0].name =
          this.$t('message.title.totalResults') + dataRows.length + this.$t('message.title.resultsNums');
        this.tableShow = true;
        this.loading = false;
        this.tableloading = false;
        this.$emit("done");
        return;
      }
      let newArray = dataRows[0].map(function (col, i) {
        return dataRows.map(function (row) {
          return row[i];
        });
      });
      // console.log(newArray);
      let tempArr = newArray.map((i) => {
        let arr = [];
        i.map((j) => {
          let n = j || [];
          return (arr = [...n, ...arr]);
        });
        return arr;
      });

      let iconColumn = [];
      if (data["tableP0"]) {
        const nameList = [...data["tableP0"].columnInfo.names];
        this.TagList = nameList.map((i, e) => ({
          title: i,
          field: i,
          icon: this.ll[e],
        }));
        console.log(this.TagList);
        this.iconType = nameList.map((i, e) => ({
          name: i,
          color: this.colorList[e],
        }));
        iconColumn = data["tableP0"].rows.map((i) => {
          let obj = {};
          i.cells.map((j, e) => {
            // let n = this.iconType[e];
            // Object.assign( obj,{ [n.name] :  +j.val ? n.color : ''})
            let n = +j.val
              ? { [this.iconType[e].name]: this.iconType[e].color }
              : {};
            Object.assign(obj, n);
          });
          return obj;
        });
      }
      let ObjectIdList = data["tableP1"].rows.map((i) => {
        const name = i.cells[0].val;
        const {
          objSubClass: subClassId,
          objClass: classId,
          objId: id,
          baseClass: baseClassId,
        } = i;
        const arr = { id, classId, subClassId, name };
        return arr;
      });

      let listData = tempArr.map((i) => {
        let temp = {};
        i.map((j, e) => {
          Object.assign(temp, { [columnlist[e].field]: j.val });
        });
        return temp;
      });
      listData.map((i, e) => {
        Object.assign(i, iconColumn[e]);
        i.ObjectId = ObjectIdList[e];
        i.itemNumber = ObjectIdList[e].name;
        i.id = ObjectIdList[e].id;
      });

      console.log(listData);


      this.linkProperty = columnlist[0].field;

      if (this.creatBy == 'BOM') {
        let systemName = window.sessionStorage.getItem("systemName");
        console.log(systemName);
        if (systemName.indexOf("奥斯汀") != -1) {
          columnlist.splice(2, 0,
            { field: 'quantity', title: '数量', width: 80, editRender: { name: "$input", attrs: { type: "text" } }, slots: { edit: 'quantityEdit' } },
            { field: 'department', title: '生产单位', width: 160, editRender: {}, slots: { default: 'departmentShow', edit: 'departmentEdit' } },
          )
        } else {
          columnlist.splice(2, 0,
            { field: 'quantity', title: '数量', width: 80, editRender: { name: "$input", attrs: { type: "text" }, activeMethod: this.activeRowMethod, }, })
        }
      }
      const tagArr = [{ field: "BomTag", slots: { default: 'BOMTagShow', } },
      { field: "pendingChangeTag", slots: { default: 'workflowTagShow', } },
      { field: "manufacturerTag", slots: { default: 'manufacterTagShow', } },
      { field: "attachmentTag", slots: { default: 'attchmentTagShow', } }];
      this.addTableList.columns = [{ type: "checkbox", width: 50 }, ...tagArr, ...columnlist];

      this.addTableList.editConfig = {
        trigger: "dblclick",
        mode: "cell",
        activeMethod: this.activeRowMethod,
        showStatus: true,
      };


      this.addTableList.data = listData;
      this.visiableData = listData;
      this.totalRols = listData.length;
      this.tableToolbar.buttons[0].name =
        this.$t('message.title.totalResults') + this.totalRecords + this.$t('message.title.resultsNums');
      // this.totalRecords = listData.length;
      this.tableShow = true;
      this.loading = false;
      this.tableloading = false;

    },




    formatDepartment(e) {
      // console.log(e);
      if (e) {
        return e.map(i => this.departmentList.find(j => j.value == i).label).join(',')
      }
      return ''
    },

    getSearch() {
      const obj = this.$refs.search.getSearchInfo();
      this.searchInfo = obj.seekVo;
      if (this.creatBy != "BOM") {
        obj.noPendingItem = this.noPendingItem ? 1 : 0;
      }
      obj.currentPage = this.currentPage;
      obj.pageSize = this.pageSize;
      axios.post("/search/advanced/search", obj).then((res) => {
        if (res.data.code == 200) {
          let data = {};
          Object.keys(res.data.object).map((i) => {
            if (i != "page") {
              data[i] = res.data.object[i];
            }
          });
          this.totalRecords = res.data.object.page.totalCount;
          this.getItemData(data);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    searchClick() {
      this.tableloading = true;
      if (this.advancedSearch) {
        this.getSearch()
      } else {
        if (this.$store.state.objectId.classId == 10410 || this.$store.state.objectId.classId.toString().substring(0, 3) == 501) {
          var obj_get = {
            //获取url参数
            baseClassId: 501,
            value: this.searchVal,
            size: this.pageSize,
            page: this.currentPage,
            classId: this.$store.state.objectId.classId
          };
        } else {
          var obj_get = {
            //获取url参数
            baseClassId: 101,
            value: this.searchVal,
            size: this.pageSize,
            page: this.currentPage,
            classId: this.$store.state.objectId.classId
          }
        };
        axios.get(`/pmdm/search/simple${this.params(obj_get)}`)
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              const { table } = res.data.object
              this.totalRecords = table.totalRecords

              this.formatTable(table)
            }
          })
      }

    },
    formatTable(data) {
      // this.totalRecords = data.totalRecords;
      if (!this.totalRecords) {
        this.$message({
          message: this.$t("message.warning.searchErr_02"),
          type: "warning",
        });
        this.addTableList.data = [];
        this.tableloading = false;
        return;
      }
      this.paginationShow = true;
      let items = data.columnInfo.names;
      let rows = data.rows;

      let typeFilter = [...new Set(rows.map(i => i.cells[2].val))].map(j => ({ 'label': j, 'value': j }));
      let lcpFilter = [...new Set(rows.map(i => i.cells[3].val))].map(j => ({ 'label': j, 'value': j }));

      this.cols = items.map((i, e) => ({ field: e, title: items[e] }));
      if (this.creatBy == 'BOM') {
        let systemName = window.sessionStorage.getItem("systemName");
        if (systemName.indexOf("奥斯汀") != -1) {
          this.cols.splice(2, 0,
            { field: 'quantity', title: '数量', editRender: { name: "$input", attrs: { type: "text" } }, slots: { edit: 'quantityEdit' } },
            { field: 'department', title: '生产单位', editRender: {}, slots: { default: 'departmentShow', edit: 'departmentEdit' } },
          )
        } else {
          this.cols.splice(2, 0,
            { field: 'quantity', title: '数量', editRender: { name: "$input", attrs: { type: "text" } }, slots: { edit: 'quantityEdit' } })
        }
      }

      this.cols.find(i => i.field == 2).filters = typeFilter;
      this.cols.find(i => i.field == 3).filters = lcpFilter;

      this.addTableList.columns = [{ type: "checkbox", width: 50 }, ...this.cols];
      this.addTableList.data = rows.map(i => {
        let el = {};
        i.cells.map((j, e) => { el[e] = j.val });
        el.itemNumber = i.cells[0].val;
        el.quantity = '';
        el.id = i.objId;
        el.authTag = i.authTag;
        el.subClassId = i.objSubClass;
        el.classId = i.objClass;
        return el;
      })

      this.tableloading = false;

    },

    add() {
      this.$emit("addNew");
    },
    toList(row) {
      //console.log(row);
      let arr = [];
      arr.push(row.row);
      this.$emit("listDbClick", arr);
    },

    async getPersonalSearchListData() {
      const { data: res } = await this.$http.get("/pmdm/menus/tree");
      let children;
      try {
        children = res.object.tree?.find(i => i.id === 104)?.children?.find(i => i.id === 10404)?.children;
        if (children) {
          this.options = children.map(item => ({
            value: item.id,
            label: item.name
          }));
        } else {
          this.options = [];
        }
      } catch (error) {
        console.error('Error fetching children:', error);
        this.options = [];
      }
    },

    handleChange(value) {
      this.addTableList.data = [];
      this.totalRecords = 0;
      this.advancedSearch = !!value;
      if (value) {
        this.messageData = this.value;
        this.$nextTick(() => {
          this.$refs.search.combineSearchCriteria(value);
        });

      } else {
        this.messageData = "NO";
      }
    },

    dbClick(params) {
      let row = [params.row];
      this.submitData(row);
    },

    checkClick() {
      let row = this.$refs.xGrid.getCheckboxRecords();
      this.submitData(row);
    },

    submitData(row) {
      for (let index = 0; index < row.length; index++) {
        row[index].isAdd = this.checkedSubMaterials ? "1" : "0";
      }
      if (row.length == 0) return false;
      let systemName = window.sessionStorage.getItem("systemName");
      let errRow = row.filter(i => !i.quantity && (i.classId !== 10301 && systemName.indexOf("帝京"))).map(i => i['0']);
      if (errRow.length && this.creatBy == 'BOM') {
        return this.$message(errRow + ' ”数量”不能为空')
      };
      if (systemName.indexOf("奥斯汀") != -1) {
        let errRow2 = row.filter(i => !i.department).map(i => i['0'])
        if (errRow2.length && this.creatBy == 'BOM') {
          return this.$message(errRow2 + ' "生产单位"不能为空')
        }
      };
      row[0].isAdvancedSearch = this.advancedSearch;
      this.$emit("listDbClick", row);
    },

    checkboxMethod({ row }) {
      console.log(row.itemRev);
      // return row.itemRev  != null;
    },
  },
  created() {
    // this.getClasses();
    if (this.$store.state.objectId.classId.toString().substring(0, 3) == 501) {
      this.advancedSearchChange = false;
    }
    this.advancedSearchShow = !this.noAdvancedSearch;

    const tenantName = window.sessionStorage.systemName;
    (tenantName.indexOf("Thondar") != -1) && (this.checkedSubMaterials = true)
  },
};
</script>
<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}
</style>